import React, { useState, useEffect } from 'react';
import ProcessFormPage from './ProcessFormPage';
import tw from 'twin.macro';

const MultiPageForm = ({ 
    formPages, 
    formSubmit, 
    formState, 
    dispatch, 
    submitButton 
}) => {
    const [activePage, setActivePage] = useState(0);

    const [errorPages, setErrorPages] = useState([]);

    // Highlight page numbers that have active errors;
    useEffect(()=> {
        if ('message' in formState){
            const message = formState.message;
            const messageJson = JSON.parse(message.text);


            const invalidFields = new Set(Object.keys(messageJson.validation_messages));
            const pagesWithErrors = formPages.map((page) => {
                const fieldErrors = page.fields.filter(({id}) => invalidFields.has(id.toString()));
                return (fieldErrors.length > 0) ? page.id : null;
            })

            setErrorPages(pagesWithErrors)

        }
    },[formState])

    return (
        <div>
            <nav tw="flex justify-between my-12 relative -mx-4">
                {[...formPages, { title: 'Done' }].map((page, i) => (
                    <div tw="font-bold inline-block bg-white relative z-20 px-4">
                        <button 
                            onClick={() => setActivePage(i)}
                            css={[
                                tw`inline-flex justify-center items-center mr-3 h-10 w-10 rounded-full border-2 border-yellow-600 font-bold`,
                                i === activePage && tw`bg-yellow-600`,
                                (errorPages.includes(i)) && tw`border-red-600 bg-red-200 animate-pulse`,
                                i === activePage && (errorPages.includes(i)) && tw`bg-red-400`,
                            ]}
                        >
                            {i + 1}

                            
                        </button>
                        {page.title}
                        
                    </div>
                ))}
                <div css={['top: 50%;', tw`absolute border border-gray-600 w-full`]} />
            </nav>
            <form onSubmit={formSubmit} id="quoteForm">
                {formPages.map(page => (
                    <ProcessFormPage
                        isActive={page.id === activePage}
                        setActivePage={setActivePage}
                        page={page}
                        formState={formState}
                        dispatch={dispatch}
                        firstPage={page.id === 0}
                        lastPage={page.id === formPages.length - 1}
                        submitButton={submitButton}
                    />
                ))}

                <pre tw="py-5">{JSON.stringify(Array.from(errorPages), null, 2)}</pre>
            </form>
        </div>
    )
}

export default MultiPageForm;